module.exports = {["template-constructor-control-anchor_picker"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="anchor-picker-wrapper">\n		<div class="anchor-picker">\n			<div class="popup">\n				<span>Click</span>\n				<div class="corner-wrapper"><div class="corner"></div></div>\n			</div>\n		</div>\n	</div>\n';
}
return __p;
},}